export function printElement(elem, append, delimiter) {
  var domClone = elem.cloneNode(true);
  // var $printSection = document.querySelector(".printSection");
  // if (!$printSection) {
  var $printSection = document.createElement('div');
  $printSection.id = 'printSection';
  document.querySelector('.v-application--wrap').appendChild($printSection);
  // document.body.appendChild($printSection);
  // }
  // if (append !== true) {
  //     $printSection.innerHTML = "";
  // }

  // else if (append === true) {
  //     if (typeof (delimiter) === "string") {
  //         $printSection.innerHTML += delimiter;
  //     }
  //     else if (typeof (delimiter) === "object") {
  //         $printSection.appendChlid(delimiter);
  //     }
  // }
  $printSection.append(domClone);
  window.onafterprint = function () {
    document.querySelector('.v-application--wrap').removeChild($printSection);
  };
}
export function capitalize(str) {
  return str[0].toUpperCase() + str.substring(1);
}
export function padNum(num) {
  return num < 10 ? '0' + num : num;
}
export function formatMoney(num) {
  if (num === undefined) num = null;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'GTQ',
  })
    .format(num)
    .substr(2);
}
export const getTotalObjectValues = (obj, key) =>
  Object.values(obj).reduce((acc, val) => (acc += val ? val[key] : 0), 0);
